import React, { useState, useEffect } from 'react';
import styled from '@emotion/styled';
import { Form, DatePicker } from 'antd';
import { getDashboardFromLocalstorage } from '../utils';
import moment from 'moment';
import { Select } from 'antd';

const { RangePicker } = DatePicker;

const StyledDashboardFilters = styled.div`
  width: 100%;
  > span {
    width: 100%;
  }
`;

const StyledContainer = styled.div`
  display: grid;
  grid-gap: 10px;
`;

const DashboardFilters = ({ scanSettingsList, filters, setFilters }) => {
  const [options, setOptions] = useState([]);

  const onRangeChange = (_, dates) => {
    const data = {
      ...filters,
      from: dates[0],
      to: dates[1]
    };
    setFilters(data);
  };

  const onChange = (_, option) => {
    const { value, children } = option.props;
    let data = {};
    if (value) {
      data = { ...filters, scan_settings_id: value, scan_settings_name: children };
    } else {
      data = { ...filters };
      delete data.scan_settings_id;
      delete data.scan_settings_name;
    }

    setFilters(data);
  };

  useEffect(() => {
    if (scanSettingsList) {
      setOptions([{ name: 'ALL SCAN SETTINGS', value: 'all' }, ...scanSettingsList]);
    }
  }, [scanSettingsList]);

  const defaultScanSettings = getDashboardFromLocalstorage('scan_settings_name') || 'ALL SCAN SETTINGS';

  const dateFormat = 'MM-DD-YYYY';

  console.log(filters);

  return (
    <StyledContainer>
      <Select
        defaultValue={defaultScanSettings}
        onChange={onChange}
        style={{ width: '100%' }}
        placeholder="SELECT SCAN SETTINGS"
      >
        {options &&
          options.map((scanSetting, index) => <Select.Option value={scanSetting.id}>{scanSetting.name}</Select.Option>)}
      </Select>
      <StyledDashboardFilters>
        <RangePicker
          onChange={onRangeChange}
          value={filters && [moment(filters.from, dateFormat), moment(filters.to, dateFormat)]}
          format={dateFormat}
          showTime={false}
          allowClear={false}
        />
      </StyledDashboardFilters>
    </StyledContainer>
  );
};

export default Form.create()(DashboardFilters);
